import _ from 'lodash'

function upperFirst (v) {
  return _.upperFirst(v)
}

function toUpper (v) {
  return _.toUpper(v)
}

export {
  upperFirst,
  toUpper
}
